import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import clsx from 'clsx';

import { TEAM_LEAGUES_PLACEHOLDER_IMAGE } from '@/components/constants/constants';
import { IDivision } from '@/entities/DistrictsData';

interface AccordionProps {
	districtName: string;
	numberOfDivisions: string;
	districtImg?: string;
	divisions: IDivision[];
}

export const Accordion = ({ districtName, numberOfDivisions, districtImg, divisions = [] }: AccordionProps) => {
	return (
		<div className="rounded-lg border border-solid border-gray-300 bg-white">
			<details className="group">
				<summary className="flex size-full cursor-pointer items-center justify-between px-3.5 py-2.5">
					<div className="flex w-full items-center gap-2 overflow-hidden text-wrap break-words">
						{districtImg ? (
							<img
								src={districtImg ? getCDNURL(districtImg, 88, 64) : getCDNURL(TEAM_LEAGUES_PLACEHOLDER_IMAGE, 88, 64)}
								alt="District image"
								className="h-8 w-11 rounded-md border border-gray-300 bg-gray-200 lg:mx-auto"
							/>
						) : null}
						<div className="flex w-full items-center gap-2">
							<div className="max-w-[700px] overflow-hidden text-wrap break-words text-2xl font-semibold leading-8 text-gray-900">
								{districtName}
							</div>

							<span className="text-base font-medium leading-6 text-gray-500">
								{numberOfDivisions} {Number(numberOfDivisions) == 1 ? 'division' : 'divisions'}
							</span>
						</div>
					</div>

					<FontAwesomeIcon icon={faAngleDown} className={`ml-2 size-4 transition-transform duration-300 group-open:rotate-180`} />
				</summary>
				<div
					className={`grid grid-rows-[1fr] overflow-hidden border-t border-solid border-gray-300 text-sm text-gray-700 opacity-100 transition-all duration-300 ease-in-out`}
				>
					{divisions.length === 0 && <p className="p-2 text-gray-500">No divisions available for this district.</p>}
					<div className="flex flex-col">
						{divisions.map((division, index) => (
							<div
								key={division.uuid}
								className={clsx('flex justify-between py-2 pl-3.5 pr-3 text-sm font-medium leading-6 text-gray-900', {
									'border-b border-gray-300': index !== divisions.length - 1
								})}
							>
								<span>{division.title}</span>
								<span className="text-gray-600 flex gap-2 items-center">
									<span className="w-[90px] text-right">{division.teamsCount} teams</span>
									<span className="text-gray-400">|</span>
									<span className="w-[90px] text-left">{division.playersCount} players</span>
								</span>
							</div>
						))}
					</div>
				</div>
			</details>
		</div>
	);
};
